var _path, _path2, _path3, _path4, _path5, _path6, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 86,
    viewBox: "0 0 428 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.031 21.9934L142.121 4.13173L134.274 21.9934H130.91L140.501 0.249023H143.583L153.142 21.9934H150.028H150.031Z",
    fill: "#F1F3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.098 0.249023L173.539 21.9934H170.457L160.867 0.249023H164.23L172.077 18.1107L179.987 0.249023H183.101H183.098Z",
    fill: "#F1F3F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.936 21.9934L202.026 4.13173L194.179 21.9934H190.816L200.406 0.249023H203.488L213.047 21.9934H209.934H209.936Z",
    fill: "#F1F3F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.151 2.95176H220.679V0.249023H238.708V2.95176H231.236V21.9934H228.153V2.95176H228.151Z",
    fill: "#F1F3F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.293 12.6118V0.249023H252.406V12.4871C252.406 17.3026 254.618 19.4756 258.541 19.4756C262.465 19.4756 264.706 17.3005 264.706 12.4871V0.249023H267.726V12.6118C267.726 18.9168 264.268 22.2406 258.508 22.2406C252.748 22.2406 249.291 18.9168 249.291 12.6118H249.293Z",
    fill: "#F1F3F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.897 19.507L281.049 17.0847C282.667 18.5452 285.439 19.6005 288.242 19.6005C292.01 19.6005 293.63 18.1401 293.63 16.2455C293.63 10.9335 280.426 14.2885 280.426 6.21149C280.426 2.85645 283.042 0 288.771 0C291.324 0 293.971 0.683476 295.777 1.92578L294.748 4.41037C292.849 3.19923 290.7 2.64041 288.769 2.64041C285.064 2.64041 283.475 4.19432 283.475 6.08893C283.475 11.4009 296.679 8.07702 296.679 16.0606C296.679 19.3844 294.001 22.243 288.24 22.243C284.908 22.243 281.638 21.1253 279.895 19.5091L279.897 19.507Z",
    fill: "#F1F3F4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 85,
    x2: 427.589,
    y2: 85,
    stroke: "url(#paint0_linear_12772_98160)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12772_98160",
    x1: 429.175,
    y1: 86.0593,
    x2: 1.58606,
    y2: 86.0593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5E9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353744,
    stopColor: "#2BB5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515014,
    stopColor: "#FF6A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661457,
    stopColor: "#C52026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958775,
    stopColor: "#C52026",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark);
export default __webpack_public_path__ + "static/media/wordmark.c72bd5cc791559b5d1f3f051daf32958.svg";
export { ForwardRef as ReactComponent };